import React, { useState } from "react";
import shortid from "shortid";
import "./file-upload.css";
import { AlertModal } from "../modal/alert-modal";
import { FileObject } from "@/src/data/types";

interface FileUploadProps {
  onChange: (files: FileObject[]) => void;
}

const PdfFileUpload: React.FC<FileUploadProps> = ({ onChange }) => {
  const [selectedFiles, setSelectedFiles] = useState<FileObject[]>([]);
  const [open, setOpen] = useState(false);

  const fileSize = (bytes: number, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;
    const newFiles: FileObject[] = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type !== "application/pdf") {
        alert("Seuls les fichiers PDF sont autorisés.");
        continue;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        newFiles.push({
          id: shortid.generate(),
          fileName: file.name,
          fileSize: file.size.toString(),
          fileType: file.type,
          fileImage: "",
          file: file,
          //fileImage: reader.result as string,
        });
        if (newFiles.length === files.length) {
          setSelectedFiles(newFiles);
          onChange(newFiles);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteFile = (id: string) => {
    const updatedFiles = selectedFiles.filter((file) => file.id !== id);
    setSelectedFiles(updatedFiles);
    onChange(updatedFiles);
  };

  const handleConfirm = async () => {
    setOpen(false);
  };

  return (
    <>
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        loading={false}
        description="Image supprimée avec succès"
      />
      <div className="fileupload-view">
        <div className="m-0 row justify-content-center">
          <div className="col-md-6">
            <div className="mt-5 card">
              <div className="card-body">
                <div className="kb-data-box">
                  <div className="kb-modal-data-title">
                    <div className="kb-data-title">
                      <h6>Sélectionner votre fichier PDF</h6>
                    </div>
                  </div>
                  <div>
                    <div className="kb-file-upload">
                      <div className="file-upload-box">
                        <input
                          type="file"
                          id="fileupload"
                          className="file-upload-input"
                          onChange={handleInputChange}
                          accept="application/pdf"
                        />
                        <span>
                          Glissez-déposez ou{" "}
                          <span className="file-link">
                            Choisissez votre fichier PDF.
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="mb-3 kb-attach-box">
                      {selectedFiles.map((file) => (
                        <div className="file-atc-box" key={file.id}>
                          {file.fileName === "application/pdf" ? (
                            <div className="file-image">
                              <i className="far fa-file-pdf"></i>
                            </div>
                          ) : (
                            <div className="file-image">
                              <i className="far fa-file-alt"></i>
                            </div>
                          )}
                          <div className="file-detail">
                            <h6>{file.fileName}</h6>
                            <p>
                              <span>
                                Taille : {fileSize(parseInt(file.fileSize))}
                              </span>
                            </p>
                            <div className="file-actions">
                              <button
                                type="button"
                                className="file-action-btn"
                                onClick={() => handleDeleteFile(file.id)}
                              >
                                Supprimer
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfFileUpload;
